import React, { useState } from "react"
import styled from 'styled-components'
import CtaQuote from "../../components/Icons/CtaQuote"
import RequestModal from "../../components/RequestModal"


const RequestFormSticky = styled.div`
  position: fixed;
  bottom: 10%;
  right: 0;
  width: 140px;
  height: 60px;
  z-index: 150;
  > button{
    border-radius: 20px 0 0 20px;
    box-shadow: 0 15px 30px rgb(0 0 0 / 15%);
    cursor: pointer;
    background-color: #fab702;
    color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 25px;
    text-align: left;
    .icon{
      display:block;
      height: 28px;
    }
    .text{
      font-size: 11px;
      line-height: 16px;
      max-width: 80px;
      width: 100%;
      margin: 0 0 0 10px;
      display: block;
      font-family: 'UniNeueBold', sans-serif;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;      
    }
    &:hover, &:focus{
      background-color:#e8a900;
    }
  }
`

const RequestQuoteCTA = ({ location }) => {
  const [isQuoteVisible, setIsQuoteVisible] = useState(false)

  const HandleModalOpen = () => {
    setIsQuoteVisible(true)
    document.querySelector("body").classList.add("modal-open")
  }
  const HandleModalClose = () => {
    setIsQuoteVisible(false)
    document.querySelector("body").classList.remove("modal-open")
  }
  
  return (
    <div location={location}>
      <RequestFormSticky>
        <button onClick={HandleModalOpen}>
          <span className="icon"><CtaQuote /></span>
          <span className="text">Request a Quote</span>
        </button>
      </RequestFormSticky>
      <RequestModal location={location} isVisible={isQuoteVisible} onClose={HandleModalClose} />
    </div>
  )
}
export default RequestQuoteCTA; 